import React from 'react';
import { useTranslation } from 'next-i18next';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';
import { I as ItemSekeleton } from './ItemSkeleton-03cEVH7e.js';

const ITEMS_COUNT = 1;
const PRICE_ITEMS_COUNT = 2;
const MiniShoppingCartContent = () => {
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "shopping-bag-popup-title" },
            React.createElement("h3", { className: "txt", "aria-label": "Shopping bag pop up." }, tHeading('shoppingCart')),
            React.createElement(Skeleton, { width: 100, marginBottom: 0 })),
        React.createElement("div", { className: "shopping-bag-list", tabIndex: 0 }, Array(ITEMS_COUNT)
            .fill(0)
            .map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(ItemSekeleton, { key: index })))),
        React.createElement("div", { className: "prices" }, Array(PRICE_ITEMS_COUNT)
            .fill(0)
            .map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", { key: index, className: "price" },
            React.createElement("div", { className: "price-title", style: { display: 'flex', justifyContent: 'flex-end' } },
                React.createElement(Skeleton, { width: "60%" })),
            React.createElement("div", { className: "price-value", style: { display: 'flex', justifyContent: 'flex-end', width: '50%' } },
                React.createElement(Skeleton, { width: "36%" })))))),
        React.createElement("div", { className: "actions" },
            React.createElement(Skeleton, { width: 150, height: 50, marginBottom: 0 }),
            React.createElement(Skeleton, { width: 150, height: 50, marginBottom: 0 }))));
};

export { MiniShoppingCartContent as M };
//# sourceMappingURL=MiniShoppingCartSkeleton-U6EZ6VaK.js.map
